import { Injectable } from '@angular/core';
import ZebraBrowserPrintWrapper from '@app/shared/browser-print-wrapper';
import { TVFTradeTagInfo } from '@app/tvf/screening/components/tag-print-modal/tag-info.interface';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TagPrintService {
  constructor(private _toastr: ToastrService) {}
  async print(data: TVFTradeTagInfo | any, showDestination: boolean = false) {
    try {
      const browserPrint = new ZebraBrowserPrintWrapper();
      const defaultPrinter = await browserPrint.getDefaultPrinter();
      browserPrint.setPrinter(defaultPrinter);
      const printerStatus = await browserPrint.checkPrinterStatus();

      const skuJundWithAsterisk = data.warningModelDiverge ? `${data.skuJund}*` : data.skuJund;
      const topLabel = showDestination ? data.destination : data.classification;
      const topLabelWithBattery =
        data.batteryPercent != null ? `${data.batteryPercent}% ${topLabel}` : topLabel;

      if (printerStatus.isReadyToPrint) {
        const zpl = `^XA
        ^PW640
        ^LL352
        ^LH0,0
        ^CF0,24

        ^FO22,24^A0N,28,28^FD${data.idTrade}^FS
        ^FO150,8^BY2
        ^BCN,56,N,N,N
        ^FD${data.idTrade}^FS

        ^FO410,30^A0N,35,35^FD${topLabelWithBattery}^FS

        ^FO96,96^BY2
        ^BCN,65,Y,N,N
        ^FD${data.eanCode}^FS

        ^FO22,196^A0N,64,64^FB596,1,0,C,0^FD${skuJundWithAsterisk}^FS
        ^FO90,252^BY2
        ^BCN,60,Y,N,N
        ^FDREC${data.imei}^FS

        ^XZ`;

        browserPrint.print(zpl);
        this._toastr.success('Etiqueta impressa com sucesso.');
      } else {
        this._toastr.error(printerStatus.errors, 'Error/s');
      }
    } catch (error) {
      throw error;
    }
  }
}
